<template>
  <GenericDrawer
    colorKey="bgDrawerApp"
    :isSubDrawer="false"
    :isOpen="isOpen"
    :topLinks="topLinks"
    :bottomLinks="bottomLinks"
    v-on="$listeners"
  />
</template>

<script>
import { APP_DRAWER_TOP, APP_DRAWER_BOTTOM } from "@/utils/links"

export default {
  name: "AppDrawer",
  components: {
    GenericDrawer: () => import("@/components/layouts/core/GenericDrawer.vue")
  },
  props: {
    isOpen: { type: Boolean, required: true }
  },
  data: () => ({
    topLinks: APP_DRAWER_TOP,
    bottomLinks: APP_DRAWER_BOTTOM
  })
}
</script>
